import * as httpService from "./_all";
export default httpService;
